export const images = [
  { id: 0, image: "", desc: "" },
  {
    id: 1,
    desc: "Calendar Planning",
    image: "https://images.pexels.com/photos/669614/pexels-photo-669614.jpeg",
  },
  {
    id: 2,
    desc: "Meeting Scheduling",
    image: "https://images.pexels.com/photos/3760431/pexels-photo-3760431.jpeg",
  },
  {
    id: 3,
    desc: "Desk with Calendar",
    image: "https://images.pexels.com/photos/3184426/pexels-photo-3184426.jpeg",
  },
  {
    id: 4,
    desc: "Team Collaboration",
    image: "https://images.pexels.com/photos/3184392/pexels-photo-3184392.jpeg",
  },
  {
    id: 5,
    desc: "Online Meeting",
    image: "https://images.pexels.com/photos/5099317/pexels-photo-5099317.jpeg",
  },
  {
    id: 6,
    desc: "Work from Home",
    image: "https://images.pexels.com/photos/4050294/pexels-photo-4050294.jpeg",
  },
  {
    id: 7,
    desc: "Notepad and Pen",
    image: "https://images.pexels.com/photos/4145001/pexels-photo-4145001.jpeg",
  },
  {
    id: 8,
    desc: "Digital Calendar",
    image: "https://images.pexels.com/photos/3206172/pexels-photo-3206172.jpeg",
  },
  {
    id: 9,
    desc: "Laptop and Planner",
    image: "https://images.pexels.com/photos/4050342/pexels-photo-4050342.jpeg",
  },
  {
    id: 10,
    desc: "Office Schedule",
    image: "https://images.pexels.com/photos/3184285/pexels-photo-3184285.jpeg",
  },
];
